var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('v-chip',{staticClass:"mt-n1 clickable",attrs:{"dark":"","small":"","label":"","color":_vm.chipColor},on:{"click":_vm.invite}},[_vm._v(" "+_vm._s(_vm.display)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }